
import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import { createSlice } from '@reduxjs/toolkit'


export const slice = createSlice({
    name: 'settings',
    initialState: {
        locale: (localStorage.getItem('currentLanguage') && localeOptions.filter(x=>x.id===localStorage.getItem('currentLanguage')).length>0) ? localStorage.getItem('currentLanguage') : defaultLocale,
    },
    reducers: {
        changeLocale: (state, action) => {
            state = { ...state, ...action.payload }
        }
    }
})

// Action creators are generated for each case reducer function
export const { changeLocale } = slice.actions

export default slice.reducer